import { useMutationWithErrorModal } from 'components/Wizards/MultiStepBlogPostWizard/useMutationWithErrorModal'
import { useOutline } from 'components/Wizards/MultiStepBlogPostWizard/OutlineProvider'

interface Props {
  onCancel?: () => void
}

export const useGenerateIntro = ({ onCancel }: Props) => {
  const { generateIntro } = useOutline()

  return useMutationWithErrorModal(generateIntro, { onCancel })
}
